require('./inputmask');

function validarPreCadastro() {
  const cpfValido =
    $('#pre_cadastro_cpf').val().replace(/\D/g, '').length === 11;

  const nomeValido =
    $('#pre_cadastro_nome').val().trim().length > 0;

  const emailValido =
    $('#pre_cadastro_email').val().trim().length > 0;

  $('#pre-cadastro-btn').prop(
    'disabled',
    !(cpfValido && nomeValido && emailValido)
  );
}

$(document).on('turbolinks:load', function () {
  $('#pre_cadastro_cpf').inputmask({
    mask: ['999.999.999-99'],
    keepStatic: true
  });

  validarPreCadastro();
});

$(document).on(
  'input',
  '#pre_cadastro_cpf, #pre_cadastro_nome, #pre_cadastro_email',
  validarPreCadastro
);
